import React from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Col, Form, Row } from 'reactstrap';
import { H5, Image } from '../../../AbstractElements';
import { CreditCardTitle } from '../../../Constant';
import cardImage from '../../../assets/images/ecommerce/card.png';
import InputControl from '../../Common/FormInputs/InputControl';
import { CardSelectType } from '../../../Data/Ecommerce/ProductPage';
const CreditCard = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useForm();

  return (
    <>
      <Col xl='8' sm='12' className='box-col-80'>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{CreditCardTitle}</H5>
          </CardHeader>
          <CardBody>
            <Form className='theme-form' >
              <Row>
                <Col md='7'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} placeholder='Card Number*' register={{ ...register('card_number', { required: 'is Required.', minLength: 16, maxLength: 16 }) }} />
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} placeholder='Firs Name*' register={{ ...register('first_Name', { required: 'is Required.' }) }} />
                  <InputControl control={control} label={false} controlInput='datepicker' className='form-control' errors={errors} register={{ ...register('ex_date', { required: 'is Required.' }) }} />
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} placeholder='Name On Card*' register={{ ...register('name_on_card', { required: 'is Required.' }) }} />
                  <InputControl control={control} label={false} options={CardSelectType} controlInput='select' className='form-select' errors={errors} register={{ ...register('select_type', { required: 'is Required.' }) }} />
                </Col>
                <Col md='5' className='text-center'>
                  <Image className='img-fluid mx-auto' src={cardImage} alt='' />
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default CreditCard;
